import React, { useState, useEffect, Children } from "react";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  ListGroup,
  ListGroupItem,
  Modal,
  ModalBody,
  ModalFooter,
  Row,
  ModalHeader,
  Label,
  Input,
} from "reactstrap";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
const ChildParts = () => {
  const location = useLocation();
  const navigate = useNavigate();
  // const partid = location.state?.id;
  // console.log("partid",partid)
  const [modalVisible, setModalVisible] = useState(false);
  const [editedPart, setEditedPart] = useState(null);
  const [childPartData, setChildPartData] = useState([]);
  const [mccpartname, setMccpartname] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [responseMessage, setResponseMessage] = useState("");
  const API_BASE_URL = "https://api.hanoch.in/api/mcc-child-parts";
  const itemsPerPage = 5;
  const [isLoading, setIsLoading] = useState(false);
  const authToken = localStorage.getItem("access");
  //const authToken = JSON.parse(localStorage.getItem("authUser")).token;
 const [parts, setParts] = useState([]);
   const [partData, setPartData] = useState([]);
  const selectedMachine = localStorage.getItem("selectedMachineId") || "74";
  const [selectedPart, setSelectedPart] = useState("");
  const [formData, setFormData] = useState({
    part_number: "",
    quantity: "",
    unit_cost: "",
    unit: "",
     mcc_part:selectedPart,
    currency: "",
    part_name: "",
  });

  const toggleModal = () => {
    setModalVisible(!modalVisible);
    setEditedPart(null);
  }
// Auto select first part when partData loads
useEffect(() => {
  if (partData?.length > 0 && !selectedPart) {
    setSelectedPart(partData[0].id);
  }
}, [partData]);
// Fetch child parts whenever selectedPart changes
useEffect(() => {
  if (selectedPart) {
    fetchChildParts();
    setCurrentPage(1); // reset pagination on change
  }
}, [selectedPart]);

  useEffect(() => {
  fetchPart();
  }, []);

  useEffect(() => {
    if (editedPart) {
      setFormData({
        part_number: editedPart.part_number,
        part_name: editedPart.part_name,
        quantity: editedPart.quantity,
        unit_cost: editedPart.unit_cost,
        currency: editedPart.line_cost,
        mcc_part: selectedPart,
        unit: editedPart.unit,
      });
    } else {
      setFormData({
        part_number: "",
        part_name: "",
        quantity: "",
        unit_cost: "",
       mcc_part: selectedPart,
        currency: "",
        unit: "",
      });
    }
  }, [editedPart]);
  const handleInputChange = (e) => {
    const { id, value, files, type } = e.target;
    setFormData((prev) => ({
      ...prev,
      [id]: type === "file" ? files[0] : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault()
    const formDataObject = new FormData();

    formDataObject.append("quantity", formData.quantity);
    formDataObject.append("part_number", formData.part_number);
    formDataObject.append("mcc_part", selectedPart);
    formDataObject.append("unit", formData.unit);
    formDataObject.append("is_active", true);
    formDataObject.append("currency", formData.currency);
    formDataObject.append("unit_cost", formData.unit_cost);
    formDataObject.append("part_name", formData.part_name);
    const apiUrl = editedPart
      ? `${API_BASE_URL}/${editedPart.id}/update/`
      : `https://api.hanoch.in/api/mcc-child-parts-create/`;

    try {
      const response = await fetch(apiUrl, {
        method: editedPart ? "PUT" : "POST",
        // headers: {
        //   Authorization: `Bearer ${authToken}`,
        // },
        body: formDataObject,
      });

      const responseData = await response.json();
      if (response.ok) {
        toast.success(editedPart ? "Part updated successfully" : "Part added successfully");
        setModalVisible(false);
        setFormData({
          part_number: "",
          quantity: "",
          unit_cost: "",
           mccpartid: selectedPart,
          currency: "",
          unit: "",
          part_name: "",
        });
        fetchChildParts();
      } else {
        toast.error(`Error: ${responseData.error || "Something went wrong"}`);
      }
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };



  const fetchChildParts = async () => {
    try {
      setIsLoading(true);
      // Fetch data from your API
      const response = await fetch(`https://api.hanoch.in/api/mcc-child-parts/?mcc_part_id=${selectedPart}`, {

      });
if (response.ok) {
  const data = await response.json();

  if (data.length > 0) {
    setMccpartname(data[0]?.mcc_part_name || "");
    setChildPartData(data[0]?.child_parts || []);
  } else {
    setMccpartname("");
    setChildPartData([]);
  }
}

      // if (response.ok) {
      //   const data = await response.json();
      //   setMccpartname(data[0]?.mcc_part_name ||[]);
      //   setChildPartData(data[0]?.child_parts || []);
     
      // } else if (response.status === 401) {
      //   // Unauthorized: Log out the user
      //   localStorage.removeItem("authUser");
      //   localStorage.removeItem("admin");
      // } else {
      //   console.error("error fetching child data:", response.statusText);
      // }
    } catch (error) {
      console.error("Error fetching child data:", error);
    }
    finally {
      setIsLoading(false);
    }
  };


  const fetchPart = async () => {
    try {
           setIsLoading(true);
      const response = await fetch(`https://api.hanoch.in/api/mcc-parts/?machine_id=${selectedMachine}`);
    
      if (response.ok) {
        const data = await response.json();
        setPartData(data?.data);
      } else if (response.status === 401) {
        localStorage.removeItem("authUser");
        localStorage.removeItem("admin");
      } else {
        console.error("Error fetching data:", response.statusText);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
    finally{
        setIsLoading(false);
    }
  };
 const handleDeletePart = async (id) => {
  try {
    const response = await fetch(
      `https://api.hanoch.in/api/mcc-child-parts/${id}/delete/`,
      { method: "DELETE" }
    );

    if (response.ok) {
      toast.success("Child part deleted successfully");
      fetchChildParts();
    } else {
      toast.error("Failed to delete child part");
    }
  } catch (error) {
    toast.error("Delete failed");
  }
};





  const handleSearchTermChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const filteredPart = childPartData?.filter((part) =>
    (part.part_name || "").toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Calculate the total number of pages
  const totalPages = Math.ceil(filteredPart.length / itemsPerPage);

  // Calculate the index of the first and last item of the current page
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  // Get the items for the current page
  const currentItems = filteredPart.slice(indexOfFirstItem, indexOfLastItem);

  // Handle Previous button click
  const handlePrevious = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  // Handle Next button click
  const handleNext = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="OptiMize" breadcrumbItem="Bill Of Materials" />
          <Row >
            <Col lg={12}>
              <Card>
                <CardHeader>
                  <h4 className="card-title mb-0">
                    Add, Edit & Remove 
                  </h4>
                </CardHeader>

                <CardBody>
                  <div id="customerList">
                    <Row className="align-items-end mb-3">
                    
        <Col md={4}>
    <Label>Part Name</Label>
    <Input
      type="select"
      value={selectedPart}
      onChange={(e) => setSelectedPart(e.target.value)}
    >
      <option value="">Select Part</option>
      {partData.map((part) => (
        <option key={part.id} value={part.id}>
          {part.part_name}
        </option>
      ))}
    </Input>
  </Col>
                      <Col className="col-sm-auto">
                        <div className="d-flex gap-1">
                          <Button
                            color="success"
                            className="add-btn"
                            onClick={toggleModal}
                            id="create-btn"
                          >
                            <i className="ri-add-line align-bottom me-1"></i>{" "}
                            Add Child parts
                          </Button>
                        </div>
                      </Col>
                      <Col className="col-sm">
                        <div className="d-flex justify-content-sm-end">
                          <div className="search-box ms-2">
                            <input
                              type="text"
                              className="form-control search"
                              placeholder="Search..."
                              value={searchTerm}
                              onChange={handleSearchTermChange}
                            />
                          </div>
                        </div>
                      </Col>
                    </Row>
                    {isLoading ? (
                      <div className="text-center">
                        <div className="spinner-border text-primary" role="status">
                          <span className="visually-hidden">Loading...</span>
                        </div>
                      </div>
                    ) : (
                      <div className="table-responsive table-card mt-3 mb-1">
                        <table
                          className="table align-middle table-nowrap"
                          id="customerTable"
                        >

                          <thead className="table-light">
                            <tr>
                              {/* <th className="sort" data-sort="email">
                               Part Id
                            </th> */}
                              <th className="sort" data-sort="email">
                                Child part number
                              </th>
                              <th className="sort" data-sort="email">
                                Child part Descripton
                              </th>
                              <th className="sort" data-sort="email">
                                Quantity
                              </th>
                              <th className="sort" data-sort="email">
                                Unit Cost
                              </th>
                              <th className="sort" data-sort="email">
                                Currency
                              </th>
                              <th className="sort" data-sort="email">
                                UOM
                              </th>
                              <th className="sort" data-sort="action">
                                Action
                              </th>
                            </tr>
                          </thead>
                          <tbody className="list form-check-all">
                            {currentItems === undefined ? (
                              <tr>
                                <td colSpan="3" className="text-center">
                                  Loading...
                                </td>
                              </tr>
                            ) : currentItems.length === 0 ? (
                              <tr>
                                <td colSpan="3" className="text-center">
                                  No content found
                                </td>
                              </tr>
                            ) : (
                              currentItems.map((part, index) => (
                                <tr key={index}>
                                  {/* <td className="email">
                                  {part.parent}
                                </td> */}
                                  <td>
                                    {part.part_number}
                                  </td>
                                  <td>
                                    {part.part_name}
                                  </td>
                                  <td>
                                    {part.quantity}
                                  </td>
                                  <td className="email">
                                    {part.unit_cost}
                                  </td>
                                  <td className="email">
                                    {part.currency}
                                  </td>
                                  <td className="email">
                                    {part.unit}
                                  </td>
                                  <td>
                                    <div className="d-flex gap-2">
                                      <div className="edit">
                                        <button
                                          className="btn btn-warning"
                                          onClick={() => {
                                            setModalVisible(true);
                                            setEditedPart(part);
                                          }}
                                        >
                                          Edit
                                        </button>
                                      </div>
                                      {/* <div className="remove">
                                        <button
                                          className="btn btn-danger remove-item-btn"
                                          data-bs-toggle="modal"
                                          data-bs-target="#deleteRecordModal"
                                          onClick={() =>
                                            handleDeletePart(part.id)
                                          }
                                        >
                                          Remove
                                        </button>
                                      </div> */}

                                      <button
  className="btn btn-danger remove-item-btn"
  onClick={() => {
    toast(
      ({ closeToast }) => (
        <div>
          <p>Are you sure you want to delete this child part?</p>
          <div className="d-flex justify-content-end gap-2 mt-2">
            <button
              className="btn btn-sm btn-secondary"
              onClick={closeToast}
            >
              Cancel
            </button>
            <button
              className="btn btn-sm btn-danger"
              onClick={() => {
                handleDeletePart(part.id);
                closeToast();
              }}
            >
              Delete
            </button>
          </div>
        </div>
      ),
      { autoClose: false }
    );
  }}
>
  Remove
</button>

                                    </div>
                                  </td>
                                </tr>
                              ))
                            )}
                          </tbody>
                        </table>
                        <div className="noresult" style={{ display: "none" }}>
                          <div className="text-center">
                            <lord-icon
                              src="https://cdn.lordicon.com/msoeawqm.json"
                              trigger="loop"
                              colors="primary:#121331,secondary:#08a88a"
                              style={{ width: "75px", height: "75px" }}
                            ></lord-icon>
                            <h5 className="mt-2">Sorry! No Result Found</h5>
                            <p className="text-muted mb-0">
                              We've searched more than 150+ Orders We did not find
                              any orders for you search.
                            </p>
                          </div>
                        </div>
                      </div>
                    )}
                    <div className="d-flex justify-content-end">
                      <div className="pagination-wrap hstack gap-2">
                        <Link
                          className={`page-item pagination-prev ${currentPage === 1 ? "disabled" : ""
                            }`}
                          to="#"
                          onClick={handlePrevious}
                        >
                          Previous
                        </Link>
                        <ul className="pagination listjs-pagination mb-0">
                          <li>
                            Page {currentPage} of {totalPages}
                          </li>
                        </ul>
                        <Link
                          className={`page-item pagination-next ${currentPage === totalPages ? "disabled" : ""
                            }`}
                          to="#"
                          onClick={handleNext}
                        >
                          Next
                        </Link>
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      {/* Add & Edit Child Parts */}

      <Modal
        isOpen={modalVisible}
        toggle={() => {
          setModalVisible(false);
        }}
        centered
      >
        <ModalHeader
          className="bg-light p-3"
          id="exampleModalLabel"
          toggle={() => {
            toggleModal();
          }}
        >
          {editedPart ? "Edit Part" : "Add Part"}
        </ModalHeader>
        {responseMessage && (
          <div
            className={`alert ${responseMessage.includes("Error")
              ? "alert-danger"
              : "alert-success"
              } `}
          >
            {responseMessage}
          </div>
        )}

        <form className="tablelist-form">
          <ModalBody>
            <div className="mb-3">
              <label htmlFor="part_name-field" className="form-label">
               Child Part Number
              </label>
              <input
                type="text"
                id="part_number"
                name="part_number"
                className="form-control"
                placeholder="Part Number"
                value={formData.part_number}
                onChange={handleInputChange}
                required
              />
            </div>
            <div className="mb-3">
              <label htmlFor="part_name-field" className="form-label">
                Child Part Description
              </label>
              <input
                type="text"
                id="part_name"
                name="part_name"
                className="form-control"
                placeholder="Part Name"
                value={formData.part_name}
                onChange={handleInputChange}
                required
              />
            </div>

            <div className="mb-3">
              <label htmlFor="topic-field" className="form-label">
                Quantity
              </label>
              <input
                type="text"
                id="quantity"
                name="quantity"
                className="form-control"
                placeholder="Quantity"
                value={formData.quantity}
                onChange={handleInputChange}
                required
              />
            </div>

            <div className="mb-3">
              <label htmlFor="part-description" className="form-label">
                Unit Cost
              </label>
              <input
                type="text"
                id="unit_cost"
                name="unit_cost"
                className="form-control"
                placeholder="Enter unit cost"
                value={formData.unit_cost}
                onChange={handleInputChange}
                required
              />
            </div>
            <div className="mb-3">
              <label htmlFor="part-description" className="form-label">
            Currency
              </label>
             <select
  id="currency"
  name="currency"
  className="form-control"
  value={formData.currency}
  onChange={handleInputChange}
  required
>
  <option value="">Select Currency</option>
  <option value="INR">INR</option>
  <option value="USD">USD</option>
</select>

            </div>
            <div className="mb-3">
              <label htmlFor="part-description" className="form-label">
                UOM
              </label>
             <select
  id="unit"
  name="unit"
  className="form-control"
  value={formData.unit}
  onChange={handleInputChange}
  required
>
  <option value="">Select UOM</option>
  <option value="pcs">pcs</option>
  <option value="meter">meter</option>
</select>

            </div>
          </ModalBody>
          <ModalFooter>
            <div className="hstack gap-2 justify-content-end">
              <button
                type="button"
                className="btn btn-light"
                onClick={() => setModalVisible(false)}
              >
                Close
              </button>
              <button
                type="submit"
                className="btn btn-success"
                id="add-btn"
                onClick={handleSubmit}
              >
                {" "}
                {editedPart ? "Update Child Part" : "Add Child Part"}
              </button>
              {/* <button type="button" className="btn btn-success" id="edit-btn">Update</button> */}
            </div>
          </ModalFooter>
        </form>
      </Modal>


    </React.Fragment>
  );
};

export default ChildParts;
